import "../css/login.css";
import React, { useState, useContext, useEffect } from "react";
import { PasswordInput, EmailInput } from "./Inputs";
import { authenticatedContext, userDataContext } from "../App";
import {BrowserRouter as Router,Route,Link,useLocation,} from "react-router-dom";


function LoginForm() {
  const {authenticated, setAuthenticated} = useContext(authenticatedContext);
  const {userData, setUserData} = useContext(userDataContext);
  const [passInput, setPassInput] = useState("");
  const [passInput2, setPassInput2] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (passInput.length < 8) {
      setErrorMessage("Heslo musí mít alespoň 8 znaků.");
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(passInput)) {
      setErrorMessage("Heslo musí obsahovat alespoň jeden speciální znak.");
    } else if (passInput !== passInput2) {
      setErrorMessage("Hesla se musí shodovat.");
    } else {
      console.log("Form submitted with value:");
      setErrorMessage("");
    }
  };
  return (
    <form className="loginForm" onSubmit={handleSubmit}>
      <p className="formTitle">Změna hesla</p>
      <label htmlFor="email" className="visually-hidden">
        Enter your email
      </label>
      <PasswordInput passInput={passInput} setPassInput={setPassInput} />
      <PasswordInput
        passInput={passInput2}
        setPassInput={setPassInput2}
        placeholder={"Zadejte heslo znovu"}
      />
      <label htmlFor="password" className="visually-hidden">
        Enter your password
      </label>
      <button type="submit" className="submitButton">
        změnit
      </button>
      {errorMessage && <div className="form-error-mess">{errorMessage}</div>}
    </form>
  );
}

function LoginPage() {
  return (
    <>
      <main className="mainContent">
        <header className="banner">
          <img
            loading="lazy"
            src="/img/logo_text_bg.png"
            alt="Peer Sight Logo"
          />

          <section className="systemInfo">Chytrý evidenční systém</section>
        </header>
        <section className="loginSection">
          <LoginForm />
          <div className="info">
            <p className="accountRequest">
              Pro vytvoření uživatelského účtu požádejte administrátora vaší
              organizace.
            </p>
          </div>
        </section>
      </main>
    </>
  );
}

export default LoginPage;
